import { Popover } from "antd";
import React from "react";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";
import { useGetRole } from "../../../generic/hooks/useGetRole";
import { useNavigate } from "react-router-dom";
import BlockPopoverContent from "./BlockPopoverContent";
import { useSetRecoilState } from "recoil";
import { coordinatorDetails } from "../../../../components/recoil/coordinatorRecoil";
import StatusTag from "./StatusTag";

const VisitBlocksList = ({ tagWidth, careplan, visitList }) => {
  const navigate = useNavigate();
  const role = useGetRole();
  const setCoordinatorDetails = useSetRecoilState(coordinatorDetails);

  const handleFormView = async (visit, readOnly) => {
    setCoordinatorDetails(visit?.coordinator);
    const visitForm =
      visit?.formIdentifier && JSON.parse(visit?.formIdentifier);

    navigate(
      `${RoleToLinkMapper(role)}form-viewer?templateCode=${
        visitForm[0]?.templateCode
      }&patientIdentifier=${careplan?.patientIdentifier}&workforceIdentifier=${
        visit?.workforceIdentifier
      }&formIdentifier=${
        visitForm[0]?.formIdentifier
      }&readOnly=${readOnly}&opportunityId=${visit?.opportunityId}&taskId=${
        visit?.id
      }&carePlanId=${careplan?.id}`
    );
  };

  const getWorkforceInitials = (id) => {
    const workforce = careplan?.opportunities?.find(
      (item) => item.id === id
    )?.workforce;

    if (workforce?.givenName && workforce?.familyName)
      return `${workforce?.givenName?.charAt(0)}${workforce?.familyName?.charAt(
        0
      )}`.toUpperCase();
    if (workforce?.givenName && !workforce?.familyName)
      return workforce?.givenName?.charAt(0).toUpperCase;
    if (!workforce?.givenName && workforce?.familyName)
      return workforce?.familyName?.charAt(0).toUpperCase;
    return null;
  };

  return (
    <div
      style={{
        display: "flex",
        gap: 8,
      }}
    >
      {visitList?.map((visit, index) => (
        <Popover
          arrowPointAtCenter
          placement="topRight"
          content={<BlockPopoverContent visit={visit} careplan={careplan} />}
          overlayClassName="actioncard-popover"
          key={index}
        >
          <>
            <StatusTag
              status={visit?.status}
              label={getWorkforceInitials(visit?.opportunityId)}
              style={{
                width: tagWidth,
                borderRadius: visit?.coordinator ? "50%" : 4,
              }}
              onClick={() => handleFormView(visit, true)}
            />
          </>
        </Popover>
      ))}
    </div>
  );
};

export default VisitBlocksList;
